import React, {Component, Fragment} from 'react';
import './Navigation.css';
import '../../../Common/Responsive.css';
import {Link} from 'react-router-dom';
import JapanFlag from '../../../../assets/img/japanFlag.jpg';
import KitCutLogo from '../../../../assets/img/kitcut_logo.png';
import {FormattedMessage} from "react-intl";
import Switch from "react-switch";
import ContactUs from "./ContactUs/ContactUs";
import ImagePCB from "../../../../assets/img/pcb_toggle.jpg";
import ImageStencil from "../../../../assets/img/stencil_toggle.jpg";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import PCBQuotationForm from "../../QuotationForm/PCBQuotationForm/PCBQuotationForm";
import StencilQuotationForm from "../../QuotationForm/StencilQuotationForm/StencilQuotationForm";
import {BASE_URL, PAGE_OPEN_TYPE1} from "../../../../configuration";
import {toast} from "react-toastify";
import {css} from "glamor";
import {Navbar, NavItem, NavDropdown, Nav, li} from 'react-bootstrap';
import MenuItem from "react-bootstrap/es/MenuItem";
import {PAGE_OPEN_TYPE} from "../../../../configuration";
import $ from 'jquery'

const LoginLogoutAccountLink = (props) => {


    if (localStorage.getItem("logStatus") !== "logged") {
        return (
            <Link id="login-link" to="/login"
                  onClick={() => {
                      sessionStorage.setItem("a", 'logout');
                      document.cookie = "isLog=logging";

                  }}
            >
                         <span>
                             <FormattedMessage id='app.navigation.login'
                                               defaultMessage='LOGIN'
                                               description=''/>
                         </span>
            </Link>
        )
    } else {
        return (
            <Fragment>
                <Link to="/logout"
                      onClick={() => {
                          sessionStorage.setItem("a", 'logout');
                          document.cookie = "isLog=logout";
                          InitialQuotationState.isLogged = false;

                      }}
                >

                        <span>
                            <FormattedMessage id='app.navigation.logout'
                                              defaultMessage='Logout'
                                              description=''/>
                        </span>

                </Link> &nbsp;
                {/*<Link to="/order/all">*/}

                {/*        <span>*/}
                {/*            {InitialQuotationState.naviUserName}*/}
                {/*        </span>*/}

                {/*</Link>*/}
            </Fragment>
        )
    }
};

const AdminLink = (props) => {
    if (localStorage.getItem("userRole") === "ROLE_ADMIN") {
        return (
            <Link to="/admin/inquiries/viewAll">
                    <span>
                        <FormattedMessage id='app.navigation.admin'
                                          defaultMessage='Admin'
                                          description=''/>
                    </span>
            </Link>

        )
    }
    return null;
};

const CreateNewAccountLink = (props) => {
    if (localStorage.getItem("logStatus") !== "logged") {
        return (

            <Link to="/register">
                            <span className="create-account-span">
                            <FormattedMessage id="app.navigation.register"
                                              defaultMessage="Create new account"
                                              description=""/>
                            </span>
            </Link>

        )
    }
    return null;
};

let screenWebView = true;

class Navigation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            langValue: InitialQuotationState.lang,
            checked: false,
            pcbMode: true,
            quotationPcb: {
                orderType: 1,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },
            quotationStencil: {
                orderType: 3,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            }
        };

        this.handleChange = this.handleChange.bind(this);
        this.toPcbQuotation = this.toPcbQuotation.bind(this);
        this.toStencilQuotation = this.toStencilQuotation.bind(this);
        this.collapseClick = this.collapseClick.bind(this);
        this.goToPcbEstimation = this.goToPcbEstimation.bind(this);
        this.goToStencilEstimation = this.goToStencilEstimation.bind(this);
    }

    handleChange(checked) {
        this.setState({checked});
        this.props.onLanguageChange(checked);
    }

    componentDidMount() {
        if (window.innerWidth > 993) {
            screenWebView = true;

        } else {
            screenWebView = false;
        }
        if (!this.props.loggedIn && this.props.userData !== null && sessionStorage.getItem("a") !== null) {
            if (sessionStorage.getItem("a") !== 'logout') {
                // console.log("Window location ==> ", window.location.href);
                // this.props.keycloak.login({redirectUri: window.location.href});
            }
        }

        if (InitialQuotationState.lang === "ja") {
            this.setState({
                checked: true
            })
        }
    }

    componentWillUnmount() {
        sessionStorage.setItem("a", 'logout');
    }

    toPcbQuotation = (event) => {

        localStorage.setItem("type", 1);
        localStorage.setItem("type1q", JSON.stringify(InitialQuotationState.quotation));

        window.open(BASE_URL + 'quotation/pcb', '')

    };

    toStencilQuotation = (event) => {

        localStorage.setItem("type", 3);
        localStorage.setItem("type3q", JSON.stringify(InitialQuotationState.quotation3));

        window.open(BASE_URL + 'quotation/stencil', '')

    };

    collapseClick = () => {
        $('.navbar-toggle ').click();
    };

    goToPcbEstimation = () => {
        let elm = document.getElementById("pcb");
        // console.log("PCB ID ====> ", elm);
        setTimeout(() => {
            if (elm !== null) {
                elm.click();
                console.log("PCB ID ====> ", elm);
            }
        }, 5);

    };
    goToStencilEstimation = () => {
        let elm = document.getElementById("stencil");
        // console.log("stencil ID ====> ", elm);

        setTimeout(() => {
            if (elm !== null) {
                elm.click();
                console.log("stencil ID ====> ", elm);
            }
        }, 5);
    };


    render() {
        let locationUrl = window.location.href;
        if (locationUrl === BASE_URL + 'cart') {
            if (document.getElementById("footer-margin-cart") !== null) {
                document.getElementById("footer-margin-cart").style.marginBottom = "250px";
            }
        } else if (locationUrl === BASE_URL + 'quotation/pcb' || locationUrl === BASE_URL + 'quotation/stencil') {
            if (document.getElementById("footer-margin-cart") !== null) {
                document.getElementById("footer-margin-cart").style.marginBottom = "100px";
            }
        } else {
            if (document.getElementById("footer-margin-cart") !== null) {
                document.getElementById("footer-margin-cart").style.marginBottom = "0";
            }
        }
        return (
            <Fragment>
                <div id="To_Hide_Navbar" className="top-navBar-align">
                    <Navbar>
                        <Navbar.Header>
                            <Navbar.Text>
                                {localStorage.getItem("logStatus") === "logged" ?
                                    <span className="top-nav-links">
                                    <Link to="/order/all">
                                    <span>
                                    <FormattedMessage id="app.navigation.My-Page"
                                              defaultMessage="My-Page"
                                              description=""/>
                                    </span>

                                    </Link>
                                    </span> : ''
                                }
                                <span className="top-nav-links">
                                    <Link to='/cart'>
                            <span>
                            <FormattedMessage id="app.navigation.cart"
                                              defaultMessage="CART"
                                              description=""/>
                             <sup className="badge cart-item-count-badge">
                                 {this.props.cartItemsCount}
                             </sup>
                            </span>

                               </Link>
                               </span>
                                <span className="top-nav-links">
                                   <AdminLink isAdmin={this.props.isAdmin}
                                              authenticate={this.props.authenticate}/>
                               </span>
                            <span className="top-nav-links">
                                    <LoginLogoutAccountLink userData={this.props.userData}
                                                            loggedIn={this.props.loggedIn}
                                                            user={this.props.user}
                                                            authenticate={this.props.authenticate}/>
                               </span>
                            <span className="top-nav-links">
                                    <CreateNewAccountLink userData={this.props.userData}
                                                          loggedIn={this.props.loggedIn}
                                                          authenticate={this.props.authenticate}/>
                               </span>


                            </Navbar.Text>


                        </Navbar.Header>
                    </Navbar>
                </div>
                {!screenWebView ?
                    <Navbar inverse collapseOnSelect>
                        <Navbar.Header>
                            <img className="kitcut-logo" src={KitCutLogo} alt="KITCUT"/>
                        </Navbar.Header>
                    </Navbar>
                    :
                    <div id="to_hide_navbar" className="container-fluid nav-div ">
                        <div className="eeea">
                            <div className="col-md-4">
                                {/*<Link to='/quotation/pcb'
                                      target=""
                                      id="pcb-home-page-btn-to-quotation"
                                      onClick={() => {
                                          this.collapseClick();
                                          localStorage.setItem("fromNavi", 2);
                                          localStorage.setItem("type", 1);
                                          localStorage.setItem("type1q", JSON.stringify(InitialQuotationState.quotation));
                                          this.goToPcbEstimation();
                                      }}
                                >*/}
                                {/*<a href={BASE_URL + 'quotation/pcb'}>*/}
                                    <span className="lower-navbar-left-content">
                                        <div className=" col-md-4">
                                            <img className="kitcut-logo" src={KitCutLogo} alt="KITCUT"/>
                                        </div>
                                    </span>
                                {/*</a>*/}
                                {/*</Link>*/}
                            </div>
                            <div className="col-md-8 container-div-web">
                                {/*<div className="col-md-2">*/}

                                {/*</div>*/}
                                {/*<div className="col-md-2 no-padding lower-navbar-right-content">
                                    <div className="dropdown-nav dropdown-nav-web">
                                    <span className="sub-title-span sub-title-span-radius">
                                        <FormattedMessage id="app.navigation.service"
                                                          defaultMessage="Service"
                                                          description=""/>
                                    </span>
                                        <div className=" dropdown-content  dropdown-width-ie">
                                            <div className="service-dropdown-content">

                                                <Link
                                                    id="pcb-home-page-btn-to-quotation"
                                                    onClick={() => {
                                                        localStorage.setItem("fromNavi", 1);
                                                        localStorage.setItem("type", 1);
                                                        localStorage.setItem("type1q", JSON.stringify(InitialQuotationState.quotation));
                                                        this.goToPcbEstimation();
                                                    }}
                                                    to='/quotation/pcb'
                                                    target=""
                                                >
                                                    <li>
                                                        <FormattedMessage id="app.navigation.pcb-quotation"
                                                                          defaultMessage="PCB Quotation"
                                                                          description=""/>

                                                    </li>

                                                </Link>
                                                <hr className="dotted dotted-service"/>


                                                <Link
                                                    id="stencil-home-page-btn-to-quotation"
                                                    onClick={() => {
                                                        localStorage.setItem("fromNavi", 1);
                                                        localStorage.setItem("type", 3);
                                                        localStorage.setItem("type3q", JSON.stringify(InitialQuotationState.quotation3));
                                                        this.goToStencilEstimation();
                                                    }}
                                                    to='/quotation/stencil'
                                                    target=""
                                                >

                                                    <li>
                                                        <FormattedMessage id="app.navigation.smt-quotation"
                                                                          defaultMessage="SMT Quotation"
                                                                          description=""/>
                                                    </li>

                                                </Link>

                                            </div>
                                        </div>
                                    </div>

                                </div>*/}

                                {/*<div className="col-md-2 no-padding lower-navbar-right-content">
                                    <div className="dropdown-nav dropdown-nav-web">
                                <span className="sub-title-span sub-title-span-radius">
                                    <FormattedMessage id="app.navigation.user-guide"
                                                      defaultMessage="User Guide"
                                                      description=""/>
                                </span>

                                        <div className="dropdown-content dropdown-content-width-set">
                                            <div className="user-guide-dropdown-content">
                                                <div className="col-md-4">
                                                    <Link to="/beginners"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.beginners"
                                                                              defaultMessage="Beginners"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>

                                                    <Link to="/flow"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.flow"
                                                                              defaultMessage="Flow"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>

                                                    <a href="https://kitcutlabo.blog/kitcut-pcb-standards"
                                                       target={PAGE_OPEN_TYPE}
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.spec"
                                                                              defaultMessage="Spec"
                                                                              description=""/>
                                                        </li>
                                                    </a>

                                                    <hr className="dotted"/>

                                                    <Link to="/delivery"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.delivery"
                                                                              defaultMessage="Delivery"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                </div>

                                                <div className="  col-md-4">

                                                    <Link to="/payment"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.payment"
                                                                              defaultMessage="Payment"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>

                                                    <Link to="/calendar"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.calendar"
                                                                              defaultMessage="Calendar"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>

                                                    <Link to="/article/list"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.information"
                                                                              defaultMessage="Information"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>
                                                </div>

                                                <div className="  col-md-4">

                                                    <Link to="/guide"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.guide"
                                                                              defaultMessage="Guide"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>

                                                    <Link to="/warranty"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.warranty"
                                                                              defaultMessage="Warranty"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>

                                                    <Link to="/privacy"
                                                          target=""
                                                    >
                                                        <li>
                                                            <FormattedMessage id="app.navigation.privacy"
                                                                              defaultMessage="Privacy"
                                                                              description=""/>
                                                        </li>
                                                    </Link>

                                                    <hr className="dotted"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>*/}
                                {/*<div className="col-md-2 no-padding lower-navbar-right-content">
                                    <div className="dropdown-nav dropdown-nav-web">
                                <span className="sub-title-span sub-title-span-radius">
                                    <FormattedMessage id="app.navigation.support"
                                                      defaultMessage="Support"
                                                      description=""/>
                                </span>
                                        <div className="dropdown-content">
                                            <div className="support-dropdown-content">
                                                <Link to={{
                                                    pathname: '/frequent',
                                                }}
                                                >

                                                    <li>
                                                        <FormattedMessage id="app.navigation.frequently-asked-questions"
                                                                          defaultMessage="Frequently Asked Questions"
                                                                          description=""/>
                                                    </li>
                                                </Link>

                                            </div>
                                        </div>
                                    </div>
                                </div>*/}

                                {/*<div className="col-md-2 no-padding lower-navbar-right-content">
                                    <div className="dropdown-nav-profile dropdown-nav-web">

                                        <a href="https://kitcutlabo.blog/"
                                           target={PAGE_OPEN_TYPE}
                                        >
                                            <span
                                                className="sub-title-span sub-title-span-radius sub-title-span-radius-link ">
                                            ブログ
                                            </span>

                                        </a>

                                    </div>
                                </div>*/}

                                {/*<div className="col-md-2 no-padding lower-navbar-right-content">
                                    <ContactUs userId={this.props.userId}/>
                                </div>*/}

                                {/*<div className="col-md-2 no-padding lower-navbar-right-content">
                                    <div className="dropdown-nav-profile dropdown-nav-web">

                                        <Link to={{
                                            pathname: '/companyProfile',
                                        }}
                                        >
                                            <span
                                                className="sub-title-span sub-title-span-radius sub-title-span-radius-link ">
                                            運営会社
                                            </span>

                                        </Link>

                                    </div>
                                </div>*/}
                                {/*<div className="col-md-1">*/}

                                {/*</div>*/}

                            </div>

                        </div>
                    </div>
                }
            </Fragment>

        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/Navigation.js